import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

// const baseUrl = config.baseUrl;
// const service = 'jernygateway';

// krakend - KDesk
const baseUrl = 'http://localhost:8080';
const service = 'datacollector';

class DataEnvelopeService extends ServiceBase {
    /**
     * Fetches all DataEnvelope for the current user.
     * @returns {Promise}
     */
    getDataEnvelope = () => {
        const url = `${baseUrl}/${service}/DataEnvelope`;
        const config = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, config);
    };

    /**
     * Saves a new or updated DataEnvelope.
     * @param {object} dto - { rk?, title, body, format, templateVer }
     * @returns {Promise}
     */
    postDataEnvelope = (dto) => {
        const url = `${baseUrl}/${service}/data/event`;
        const config = {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                'Content-Type': 'application/json',
            },
        };
        return agent.post(url, { data: dto }, config);
    };

    /**
     * Updates DataEnvelope
     * @param {object} req DataEnvelope
     * @returns {Promise}
     */
    patchDataEnvelope = (req) => {
        const url = `${baseUrl}/${service}/DataEnvelope`;
        const cfg = {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                'Content-Type': 'application/json',
            },
        };

        // Wrap in data envelope
        return agent.patch(url, { data: req }, cfg);
    };

    /**
     * Deletes a DataEnvelope by RK.
     *
     * @param {*} dto - { Rk }
     * @returns axios response
     */
    deleteDataEnvelope = (dto) => {
        const url = `${baseUrl}/${service}/DataEnvelope`;
        const cfg = {
            data: { data: dto },
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return agent.delete(url, cfg);
    };
}

const dataEnvelopeService = new DataEnvelopeService();
export default dataEnvelopeService;
